import { LESSONS } from "../const/actionTypes";
import { callAjax } from "../../auth/ApiAuth";

export const setLessons = (item) => {
    item.forEach(element => {
        element['title'] = 'K: ' + element['driverFullName'] + '\n';
        element['title'] += 'Tel: ' + element['driverPhoneNumber'] + '\n';
        element['title'] += element['location'] ? 'Lok: ' + element['location'] + '\n' : 'Lok: Brak\n';
        element['title'] += 'Lp: ' + element['driverLessons']+ '\n';
        element['title'] += 'Opis: ' + (element['description']==null ? "Brak" : element['description']) + '\n'
        element['start'] = new Date(element['start']);
        element['end'] = new Date(element['end']);
    });
    return {
        type: LESSONS.SET_LESSONS,
        item
    }
}
export const setAllLessons = (item) => {
    item['title'] = 'K: ' + item['driverFullName'] + '\n';
    item['title'] += 'Tel: ' + item['driverPhoneNumber'] + '\n';
    item['title'] += item['location'] ? 'Lok: ' + item['location'] + '\n' : 'Lok: Brak\n';
    item['title'] += 'Lp: ' + item['driverLessons'];
    item['title'] += 'Opis: ' + item['description'] + '\n';
    item['start'] = new Date(item['start']);
    item['end'] = new Date(item['end']);
    return {
        type: LESSONS.SET_ALL_LESSONS,
        item
    }
}
export const setUserCounter = (userID, counter, realCounter) => {
    let item = {
        'userID': userID,
        'counter': counter,
        'realCounter': realCounter
    }
    return {
        type: LESSONS.SET_USER_COUNTER,
        item
    }
}
export const setTypeCounter = (accountType, counter) => {
    let item = {
        'accountType': accountType,
        'counter': counter
    }
    return {
        type: LESSONS.SET_TYPE_COUNTER,
        item
    }
}
export const setCounterLoading = (state) => {
    return {
        type: LESSONS.SET_COUNTER_LOADING,
        state
    }
}

export const clearLessons = () => ({
    type: LESSONS.CLEAR_LESSONS
});

function fetchLessons(startDate=null, endDate=null, teacherID=null){
    let baseurl = `${process.env.REACT_APP_BASE_URL}/api/lessons/`;
    const params = []
    if (startDate && endDate){
        params.push(`startDate=${startDate}`)
        params.push(`endDate=${endDate}`)
    }
    if (teacherID!==null){
        params.push(`teacher=${teacherID}`)
    }
    if (params.length>0){
        baseurl += `?${params.join('&')}`
    }
    let result = callAjax(baseurl);
    return result
}

// Fetch only lessons without assigned drivers
function fetchUnassignedLessons(startDate=null, endDate=null, filters={}){
    let baseurl = `${process.env.REACT_APP_BASE_URL}/api/lessons/unassigned/`;
    const params = []
    if (startDate && endDate){
        params.push(`startDate=${startDate}`)
        params.push(`endDate=${endDate}`)
    }
    const { driver, user } = filters || {}
    if (driver !== undefined && user !== undefined) {
        // Prioritize driver
        params.push(`driver=${driver}`)
    } else if (driver !== undefined) {
        params.push(`driver=${driver}`)
    } else if (user !== undefined) {
        params.push(`user=${user}`)
    }
    if (params.length>0){
        baseurl += `?${params.join('&')}`
    }
    let result = callAjax(baseurl);
    return result
}

function fetchUserCounter(userID, start, end){
    let baseurl = `${process.env.REACT_APP_BASE_URL}/api/counter/?user=` + userID + '&start=' + start + '&end=' + end;
    let result = callAjax(baseurl)
    return result
}

function fetchTypeCounter(accountType, start, end){
    let baseurl = `${process.env.REACT_APP_BASE_URL}/api/counter/?accountType=` + accountType + '&start=' + start + '&end=' + end;
    let result = callAjax(baseurl)
    return result
}

export function getLessons(startDate, endDate, teacherID=null) {
    return async (dispatch) => {
        let Lessons = await fetchLessons(startDate, endDate, teacherID);
        dispatch(clearLessons());
        await dispatch(setLessons(Lessons));
    }
}

export function getAllLessons(teacherID=null) {
    return async (dispatch) => {
        let Lessons = await fetchLessons(null, null, teacherID);
        Lessons.forEach(lesson => dispatch(setAllLessons(lesson)));
    }
}

export function getUnassignedLessons(startDate, endDate, teacherID=null, filters={}) {
    function filter(element, index, array){
        return element['teacher']===teacherID;
    }
    return async (dispatch) => {
        let Lessons = await fetchUnassignedLessons(startDate, endDate, filters);
        dispatch(clearLessons());
        if (teacherID!=null) {
            Lessons = Lessons.filter(filter);
        }
        await dispatch(setLessons(Lessons));
    }
}

export function getUserCounter(userID, start, end) {
    return async (dispatch) => {
        let counter = await fetchUserCounter(userID, start, end);
        dispatch(setUserCounter(userID, counter[0]['summaryTimeOfLessons'], counter[0]['realTimeOfLessons']));
    }
}
export function getTypeCounter(accountType, start, end) {
    return async (dispatch) => {
        let counter = await fetchTypeCounter(accountType, start, end);
        dispatch(setTypeCounter(accountType, counter));
    }
}


export default (
    setLessons,
    getLessons,
    getAllLessons,
    clearLessons
)
